import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
} from 'react-query';
import { ReadOnlyListAllCategories200Response } from '../openapi';
import { ReadOnlyClient } from '../clients/readonly';
import { typesense } from '../clients/typesense';
import { SearchResponse } from 'typesense/lib/Typesense/Documents';

export const useCategoriesQuery = (
  params: { limit: number },
  options?: UseInfiniteQueryOptions<ReadOnlyListAllCategories200Response>
): UseInfiniteQueryResult<ReadOnlyListAllCategories200Response> =>
  useInfiniteQuery({
    queryKey: ['categories', params],
    queryFn: ({ pageParam }) =>
      ReadOnlyClient.readOnlyListAllCategories(pageParam, params.limit).then(
        ({ data }) => data
      ),
    ...options,
  });

// typesense

const formatHits = (result: SearchResponse<any>) =>
  result.hits
    ? result.hits.map(({ document }: any) => ({
        id: document.data.id,
        label: document.data.name,
        displayText: document.data.display_text,
        childrenCount: document.metadata.children_ids.length,
      }))
    : [];

export const searchCategories = async (query: string) =>
  typesense
    .collections('GPC')
    .documents()
    .search({
      q: query,
      query_by: 'data.name,data.display_text',
      limit: 10,
    })
    .then(formatHits);

export const getChildCategories = async (parentId: string | undefined) =>
  typesense
    .collections('GPC')
    .documents()
    .search({
      q: '*',
      filter_by: `metadata.parent_id:=[${parentId}]`,
      sort_by: 'data.name:asc',
      limit: 100,
    })
    .then(formatHits);

export const getParentCategories = async () =>
  typesense
    .collections('GPC')
    .documents()
    .search({
      q: '*',
      filter_by: 'metadata.is_root_category:[true]',
      sort_by: 'data.name:asc',
      limit: 25,
    })
    .then(formatHits);
